import Axios from 'middleware/axiosInstance'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import "./login.scss"
import closeEye from "../../assets/images/eye-close-white.svg"
import openEye from "../../assets/images/eye-open-white.svg"
import LoadingForButton from "../../layouts/LoadingForButton/LoadingForButton"

const Login = () => {

    const navigate = useNavigate()
    const [loginInfo, setLoginInfo] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [userPassIsWrong, setUserPassIsWrong] = useState(false);
    const [inProccess, setInProccess] = useState(false);
    const handleLoginInfoChange = (e) => {
        userPassIsWrong && setUserPassIsWrong(false)
        const value = e.target.value;
        const name = e.target.name;
        setLoginInfo({ ...loginInfo, [name]: value });
    };
    const handleLogin = (e) => {
        setInProccess(true)
        e.preventDefault();
        Axios.post("/login", loginInfo).then(async res => {
            if (res.data.status === "success") {
                try {
                    // get api token and save in localstorage
                    await localStorage.setItem("token", res.data.authorisation.token)
                    // account owner name

                    navigate("/")
                }
                catch {
                    alert("در ذخیره پارامترهای ورودی مشکلی پیش آمده")
                }
            }
            else {
                alert("در ذخیره پارامترهای ورودی مشکلی پیش آمده")
            }
        }

        ).catch(err => {
            if (err.response.status === 403 || err.response.status === 404) {
                setUserPassIsWrong(true)
            }
            else {
                alert(err.response.data.message)
            }
        }
        ).finally(() => setInProccess(false))
    }
    const signUp = () => {
        alert("لطفا جهت تهیه اشتراک و یا بازیابی رمز عبور با پشتیبانی به شماره 32176-025 تماس بگیرید!")
    }
    return (
        <div className='h-100vh w-100vw d-flex justify-content-center align-items-center login-background'>
            <div className='login-container'>
                <form className='d-flex flex-column align-items-center justify-content-start h-100 mt-4'
                    autoComplete="off" onSubmit={handleLogin}>
                    <p className={`${userPassIsWrong ? "wrong-login-message-show" : null} wrong-login-message`}>
                        نام کاربری و رمز عبور وارد شده مطابقت ندارند
                    </p>
                    <div className="login-input-box">
                        <input type="text" id="email" name="email"
                            placeholder="test@gmail.com"
                            onChange={handleLoginInfoChange}
                            required
                        />
                        <label htmlFor="email">نام کاربری</label>
                    </div>
                    <div className="login-input-box">
                        <input type={showPassword ? "text" : "password"} id="password" name="password"
                            placeholder="password"
                            required
                            onChange={handleLoginInfoChange}
                        />
                        <label htmlFor="password">رمز عبور</label>
                        <img src={showPassword ? closeEye : openEye} className="show-hide-password-icon"
                            onClick={() => setShowPassword(!showPassword)}
                            alt="icon" />
                    </div>
                    <p className='signup' onClick={signUp}>
                        عضویت/فراموشی رمز
                    </p>
                    <button disabled={inProccess} className='login-button'  >
                        {inProccess ? <LoadingForButton /> : "ورود"}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default Login